import { render_gradient_colors } from './cb_chart_util.js'

let default_paint_options = {
}
class CBChartPaint {
  constructor(options) {
    this.options = Object.deepAssign({}, default_paint_options, options)
  }

  draw(data, canvas, scale_x, scale_y) {
    console.error("Not Implemented")
    return this
  }
}

class CBLineChartPaint extends CBChartPaint {
  draw(dataset, canvas, scale_x, scale_y) {
    let ctx = canvas.getContext("2d")

    if (dataset.length > 0) {
      ctx.strokeStyle = this.options.color || 'black'
      ctx.globalAlpha = this.options.opacity || 1
      ctx.lineWidth = this.options.line_width || 1
      ctx.beginPath()

      let data = dataset[0]
      ctx.moveTo(
        scale_x.position(data.x),
        scale_y.position(data.y)
      )
      if (dataset.length > 1) {
        for (let idx=1; idx<dataset.length; idx++) {
          data = dataset[idx]
          ctx.lineTo(
            scale_x.position(data.x),
            scale_y.position(data.y)
          )
        }
      }
      ctx.stroke()
      ctx.closePath()
    }

    return this
  }
}


class CBNotationChartPaint extends CBChartPaint {
  draw(dataset, canvas, scale_x, scale_y) {
    let work_space = canvas.parentNode
    if (work_space) {
      let top = scale_y.position() || 10
      let icon_ratio = this.options.icon_ratio || 0.8
      let icon_size = icon_ratio * (scale_x.canvas_range[1] - scale_x.canvas_range[0]) / dataset.length

      for (let idx=0; idx<dataset.length; idx++) {
        let data = dataset[idx]

        let img_div = document.createElement('img')
        img_div.src = data.icon
        img_div.style.position = 'absolute'
        img_div.style.top = css_unit_join(top, 'px')
        img_div.style.left = css_unit_join(scale_x.position(data.x) + 'px')
        img_div.style.transform = 'translateX(-50%) translateY(-50%)'
        if (data.rotate) {
          img_div.style.transform += 'rotate(' + data.rotate + 'deg)'
        }
        img_div.style.width = css_unit_join(icon_size, 'px')
        img_div.style.zIndex = 1

        work_space.appendChild(img_div)
      }
    }
  }
}


class CBAreaChartPaint extends CBChartPaint {
  draw(dataset, canvas, scale_x, scale_y) {
    let ctx = canvas.getContext("2d")
    ctx.globalAlpha = this.options.opacity || 0.5
    ctx.strokeStyle = "rgba(0,0,0,0)"

    if (dataset.length > 0) {
      ctx.beginPath()
      let data = dataset[0]

      ctx.moveTo(
        scale_x.position(data.x),
        scale_y.canvas_range[0]
      )
      ctx.lineTo(
        scale_x.position(data.x),
        scale_y.position(data.y)
      )
      if (dataset.length > 1) {
        for (let idx=1; idx<dataset.length; idx++) {
          data = dataset[idx]
          ctx.lineTo(
            scale_x.position(data.x),
            scale_y.position(data.y)
          )
        }
        ctx.lineTo(
          scale_x.position(data.x),
          scale_y.canvas_range[0]
        )

        if (this.options.color_table) {
          ctx.fillStyle = render_gradient_colors(
            ctx, this.options.color_table, scale_y)
        }
        else if (this.options.fill_style) {
          ctx.fillStyle = this.options.fill_style
        }

      }
      ctx.closePath()
      ctx.fill()
    }

    return this
  }
}


class CBBarChartPaint extends CBChartPaint {

  draw(dataset, canvas, scale_x, scale_y) {
    let ctx = canvas.getContext("2d")
    ctx.globalAlpha = this.options.opacity || 1

    if (dataset.length > 0) {
      ctx.beginPath()
      let bar_ratio = this.options.bar_ratio || 0.5
      let bar_width = bar_ratio * (scale_x.canvas_range[1] - scale_x.canvas_range[0]) / dataset.length

      for (let data of dataset) {
        ctx.rect(
          (scale_x.position(data.x) - bar_width / 2) - 1,
          scale_y.position(data.y),
          bar_width,
          scale_y.canvas_range[0] - scale_y.position(data.y)
        )

        ctx.fillStyle = this.options.fill || 'black'
        ctx.fill();
      }
      ctx.closePath()
    }

    return this
  }
}


export {
  CBChartPaint,
  CBLineChartPaint, CBNotationChartPaint, CBAreaChartPaint, CBBarChartPaint
}



// WEBPACK FOOTER //
// ./src/assets/cb/cb-chart/cb_chart_paint.js